(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["andarelo-help"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
if (root.__ahp) return; root.__ahp = 1;
var q = root.querySelector('[data-ahp-q]'), items = root.querySelectorAll('.ahp-q'), chips = root.querySelectorAll('[data-ahp-cat]'), empty = root.querySelector('[data-ahp-empty]'), cat = '';
function norm(s){ return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
function apply(){
var t = norm(q && q.value), shown = 0;
items.forEach(function(d){
var ok = (!cat || d.getAttribute('data-cat') === cat) && (!t || norm(d.textContent).indexOf(t) > -1);
d.hidden = !ok; if (ok) shown++;
if (t && ok) d.open = true;
});
if (empty) empty.hidden = shown > 0;
}
chips.forEach(function(c){ c.addEventListener('click', function(){ cat = c.getAttribute('data-ahp-cat'); chips.forEach(function(x){ x.classList.toggle('is-on', x === c); }); apply(); }); });
if (q) q.addEventListener('input', function(){ if (q.value) { var f = root.querySelector('.ahp-faq'); if (f && f.getBoundingClientRect().top > window.innerHeight) f.scrollIntoView({ behavior: 'smooth' }); } apply(); });
}
function all(){ document.querySelectorAll('[data-ahp]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["andarelo-product"] && !Shopify.designMode) return;
  try {
    
(function(){
function money(c, f){
var n = (c / 100).toFixed(2), m = /\{\{\s*(\w+)\s*\}\}/.exec(f || '') , k = m ? m[1] : 'amount_with_comma_separator';
var p = n.split('.'), i = p[0], d = p[1];
var s = k.indexOf('comma') > -1 ? i.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d : i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d;
if (k.indexOf('no_decimals') > -1) s = s.split(/[.,]\d\d$/)[0];
return (f || '{{amount_with_comma_separator}} €').replace(/\{\{\s*\w+\s*\}\}/, s);
}
function initGal(g){
if (g.__ap) return; g.__ap = 1;
var root = g.closest('[data-ap]');
var track = g.querySelector('[data-ap-track]'), slides = track.children, n = slides.length;
var thumbs = g.querySelectorAll('[data-ap-go]'), cur = g.querySelector('[data-ap-cur]'), bar = g.querySelector('[data-ap-bar]');
var lb = root.querySelector('[data-ap-lb]'), lbImg = root.querySelector('[data-ap-lb-img]');
var idx = 0;
function go(i, smooth){
i = (i + n) % n;
track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
set(i);
}
function set(i){
if (i === idx && cur.textContent == i + 1) return;
idx = i; cur.textContent = i + 1;
if (bar) { bar.style.width = (100 / n) + '%'; bar.style.marginLeft = (i * 100 / n) + '%'; }
thumbs.forEach(function(t, k){ t.classList.toggle('is-on', k === i); });
var t = thumbs[i];
if (t) { var box = t.parentNode; box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' }); }
[].forEach.call(slides, function(s, k){
var vd = s.querySelector('video'); if (!vd) return;
if (k === i) { vd.querySelectorAll('source[data-src]').forEach(function(x){ x.src = x.getAttribute('data-src'); x.removeAttribute('data-src'); vd.load(); }); var p = vd.play(); if (p && p.catch) p.catch(function(){}); }
else vd.pause();
});
if (lb && !lb.hidden) showLb();
}
var tm;
track.addEventListener('scroll', function(){ clearTimeout(tm); tm = setTimeout(function(){ set(Math.round(track.scrollLeft / track.clientWidth)); }, 60); }, { passive: true });
root.querySelectorAll('[data-ap-prev]').forEach(function(b){ b.addEventListener('click', function(e){ e.stopPropagation(); go(idx - 1); }); });
root.querySelectorAll('[data-ap-next]').forEach(function(b){ b.addEventListener('click', function(e){ e.stopPropagation(); go(idx + 1); }); });
thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(+t.getAttribute('data-ap-go')); }); });
g.addEventListener('keydown', function(e){ if (e.key === 'ArrowLeft') go(idx - 1); if (e.key === 'ArrowRight') go(idx + 1); });
function showLb(){ var im = slides[idx].querySelector('img'); if (!im) { lb.hidden = true; return; } lbImg.src = im.getAttribute('data-full') || im.currentSrc || im.src; }
function openLb(){ if (!slides[idx].querySelector('img')) return; lb.hidden = false; showLb(); document.documentElement.style.overflow = 'hidden'; }
function closeLb(){ lb.hidden = true; document.documentElement.style.overflow = ''; }
track.addEventListener('click', openLb);
var z = g.querySelector('[data-ap-zoom]'); if (z) z.addEventListener('click', openLb);
root.querySelector('[data-ap-lb-close]').addEventListener('click', closeLb);
lb.addEventListener('click', function(e){ if (e.target === lb) closeLb(); });
document.addEventListener('keydown', function(e){ if (lb.hidden) return; if (e.key === 'Escape') closeLb(); if (e.key === 'ArrowLeft') go(idx - 1); if (e.key === 'ArrowRight') go(idx + 1); });
window.addEventListener('resize', function(){ track.scrollTo({ left: idx * track.clientWidth, behavior: 'auto' }); });
}
function initPrice(root){
if (root.__apP) return; root.__apP = 1;
var data = root.querySelector('[data-ap-variants]'); if (!data) return;
var vs = JSON.parse(data.textContent), fmt = root.getAttribute('data-money');
function upd(id){
var v = vs.filter(function(x){ return String(x.id) === String(id); })[0]; if (!v) return;
var q = function(s){ return root.querySelector(s); };
q('[data-ap-price]').textContent = money(v.price, fmt);
var was = q('[data-ap-was]'), sv = q('[data-ap-save]'), has = v.compare_at_price > v.price;
was.hidden = !has; sv.hidden = !has;
if (has) { was.textContent = money(v.compare_at_price, fmt); sv.textContent = 'Ahorras ' + money(v.compare_at_price - v.price, fmt); }
var a = q('[data-ap-atc]'); if (a) a.textContent = v.available ? 'Añadir al carrito · ' + money(v.price, fmt) : 'Agotado';
var st = document.querySelector('[data-and-sticky-price]'); if (st) st.textContent = money(v.price, fmt);
}
root.addEventListener('click', function(e){ var c = e.target.closest && e.target.closest('[data-and-variant]'); if (c) upd(c.getAttribute('data-and-variant')); });
}
function init(){ document.querySelectorAll('[data-ap]').forEach(function(r){ var g = r.querySelector('[data-ap-gal]'); if (g) initGal(g); initPrice(r); }); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["andarelo-scrub"] && !Shopify.designMode) return;
  try {
    
(function(){
if (window.__andScrub2) return; window.__andScrub2 = true;
if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
var secs = [], raf = 0;
function setup(s){
if (s.__o) return s.__o;
var o = { el: s, cv: s.querySelector('canvas'), chaps: s.querySelectorAll('.and-scrub__chap'), dots: s.querySelectorAll('.and-scrub__dots i'), arcs: s.querySelectorAll('.and-scrub__arc'),
urls: (s.getAttribute('data-sheets') || '').split('|').filter(Boolean), N: +s.getAttribute('data-frames') || 60, C: +s.getAttribute('data-cols') || 4, R: +s.getAttribute('data-rows') || 3,
imgs: [], loaded: false, shown: 0, cur: -1, frame: -1, w: 0, h: 0 };
o.ctx = o.cv.getContext('2d');
s.__o = o; return o;
}
function load(o){
if (o.loaded) return; o.loaded = true;
o.urls.forEach(function(u, i){ var im = new Image(); im.decoding = 'async'; im.onload = function(){ im.ok = 1; o.frame = -1; kick(); }; im.src = u; o.imgs[i] = im; });
}
function size(o){
var dpr = Math.min(window.devicePixelRatio || 1, 2), w = Math.round(o.cv.clientWidth * dpr), h = Math.round(o.cv.clientHeight * dpr);
if (w && h && (w !== o.w || h !== o.h)) { o.cv.width = o.w = w; o.cv.height = o.h = h; o.frame = -1; }
}
function draw(o, k){
var per = o.C * o.R, im = o.imgs[Math.floor(k / per)];
if (!im || !im.ok) { for (var j = k; j >= 0; j--) { var a = o.imgs[Math.floor(j / per)]; if (a && a.ok) { k = j; im = a; break; } } if (!im || !im.ok) return; }
var fw = im.naturalWidth / o.C, fh = im.naturalHeight / o.R, idx = k % per, sx = (idx % o.C) * fw, sy = Math.floor(idx / o.C) * fh;
var s = Math.max(o.w / fw, o.h / fh), dw = fw * s, dh = fh * s;
o.ctx.drawImage(im, sx, sy, fw, fh, (o.w - dw) / 2, (o.h - dh) / 2, dw, dh);
o.cv.style.backgroundImage = 'none';
}
function tick(){
raf = 0; var vh = window.innerHeight, again = false;
secs.forEach(function(o){
var r = o.el.getBoundingClientRect();
if (r.top < vh * 2.5 && r.bottom > -vh) load(o);
if (r.bottom < 0 || r.top > vh) return;
size(o);
var p = Math.min(1, Math.max(0, -r.top / (r.height - vh)));
o.shown += (p - o.shown) * 0.3;
if (Math.abs(p - o.shown) > 0.0008) again = true; else o.shown = p;
var q = o.shown;
o.el.style.setProperty('--p', q.toFixed(4));
var k = Math.min(o.N - 1, Math.round(q * (o.N - 1)));
if (k !== o.frame) { draw(o, k); o.frame = k; }
var idx = Math.min(o.chaps.length - 1, Math.floor(q * o.chaps.length * 0.999));
if (idx !== o.cur) { o.chaps.forEach(function(c, i){ c.classList.toggle('is-on', i === idx); }); o.dots.forEach(function(d, i){ d.classList.toggle('is-on', i === idx); }); o.cur = idx; }
o.el.classList.toggle('is-moving', p > 0.02);
if (o.arcs[0]) o.arcs[0].style.transform = 'translate(' + (-q * 10) + 'vw,' + (-q * 16) + 'vh) scale(' + (1 + q * .2) + ')';
if (o.arcs[1]) o.arcs[1].style.transform = 'translate(' + (q * 12) + 'vw,' + (q * 10) + 'vh)';
});
if (again) raf = requestAnimationFrame(tick);
}
function kick(){ if (!raf) raf = requestAnimationFrame(tick); }
function init(){ secs = [].map.call(document.querySelectorAll('[data-and-scrub]'), setup); kick(); }
window.addEventListener('scroll', kick, { passive: true });
window.addEventListener('resize', function(){ secs.forEach(function(o){ o.w = 0; }); kick(); });
document.addEventListener('shopify:section:load', init);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["andarelo-ugc"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
if (root.__aug) return; root.__aug = 1;
var track = root.querySelector('[data-aug-track]'), vids = root.querySelectorAll('[data-aug-vid]');
function step(d){ var c = track.querySelector('.aug__card'); if (!c) return; track.scrollBy({ left: d * (c.offsetWidth + 16), behavior: 'smooth' }); }
var p = root.querySelector('[data-aug-prev]'), n = root.querySelector('[data-aug-next]');
if (p) p.addEventListener('click', function(){ step(-1); });
if (n) n.addEventListener('click', function(){ step(1); });
function play(v){ v.querySelectorAll('source[data-src]').forEach(function(s){ s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); v.load(); }); var x = v.play(); if (x && x.catch) x.catch(function(){}); }
if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) play(e.target); else e.target.pause(); }); }, { threshold: 0.35 });
vids.forEach(function(v){ io.observe(v); });
}
function all(){ document.querySelectorAll('[data-aug]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
